import React, { useState } from 'react'

const Wikilink = props => {
  // props for this file from parent
  const { editData, wikilink, active, modeUrl, sendwikilink, sendBooleanValueChangeDone } = props
  // statevariables for this file
  const [wiki, setwiki] = useState(true)
  const indication = modeUrl
    ? editData.wikilink === wikilink || active.wikipedia === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  // funtion to send input to parent and validate the url
  const wikipediaLink = event => {
    const regex = /(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[\\/\w .-]*\/?/
    if (event.target.value) {
      setwiki(regex.test(event.target.value))
    }

    sendBooleanValueChangeDone('wikipedia', true)
    sendwikilink('wikilink', event.target.value)
  }

  return (
    <div>
      <label>
        Wikilink:<div className='mandatory'>*</div>
      </label>
      <input
        type='url'
        placeholder='please enter wikipedia URL'
        value={wikilink}
        onChange={event => wikipediaLink(event)}
        style={modeUrl && indication}
        className='rounded w-100'
      />
      <div>{!wiki && <span className='mandatory1'>enter valid url</span>}</div>
      {!wikilink && <div className='mandatory1'>wikipediaLink should not be empty</div>}
    </div>
  )
}

export default Wikilink
